import { Injectable } from "@angular/core";

@Injectable()
export class LoggingService {
    constructor() {
        // can be replaced with something else
    }

    debug(message: any, ...params: any[]) {
        console.debug(message, ...params);
    }

    warn(message: any, ...params: any[]) {
        console.warn(message, ...params);
    }

    error(message: any, ...params: any[]) {
        console.error(message, ...params);
    }

    log(message: any, ...params: any[]) {
        console.log(message, ...params);
    }

    info(message: any, ...params: any[]) {
        console.info(message, ...params);
    }

    trace(message: any, ...params: any[]) {
        console.trace(message, ...params);
    }
}



// WEBPACK FOOTER //
// ./src/services/logging/logging.service.ts